import { ModelPitchRange } from "@/types/defs/modelPitchRange";

export const toModelPitchRange = (
  low: number | null,
  high: number | null
): ModelPitchRange => {
  if (low === null && high === null) {
    return null;
  }
  if (low === null || high === null) {
    // Unreachable while the model_pitch_range_both_or_neither CHECK exists — reaching this means the constraint was dropped or bypassed.
    throw new Error(`Half-set pitch range: low=${low}, high=${high}`);
  }
  return { low, high };
};
